import { Button, Container, Typography } from '@design-system';
import { HeaderToggle, HolidayItem } from '@components';
import React from 'react';
import './MesCongesPage.scss';
import { useMesCongesPageVM } from './useMesCongesPageVM';
import { BiPlus } from 'react-icons/bi';
import { MesCongesSkeleton } from './MesCongesSkeleton';

export const MesCongesPage: React.FC = () => {
    const { currentHolidays, pastHolidays, isLoading, error, navigate, operators, holidayTypes } = useMesCongesPageVM();

    if (error) {
        return <div>Error</div>;
    }

    return (
        <div className="mes-conges-page">
            {operators && currentHolidays && pastHolidays && (
                <>
                    <HeaderToggle labels={['En cours', 'Traitées']}>
                        <Container className="holidays-container">
                            {isLoading ? (
                                <MesCongesSkeleton />
                            ) : (
                                <>
                                    {currentHolidays.map((holiday) => (
                                        <HolidayItem
                                            key={holiday.id}
                                            {...holiday}
                                            holidayTypes={holidayTypes}
                                            operator={
                                                operators.find((operator) => operator.id_operator === holiday.operator_id)?.name ??
                                                'Responsable non trouvé'
                                            }
                                        />
                                    ))}

                                    {!currentHolidays.length && (
                                        <Typography intrinsic="h4" color="grey" defaultSpacing>
                                            Aucune demande d'absence en cours
                                        </Typography>
                                    )}
                                </>
                            )}
                        </Container>

                        <Container className="holidays-container">
                            {isLoading ? (
                                <MesCongesSkeleton />
                            ) : (
                                <>
                                    {pastHolidays.map((holiday) => (
                                        <HolidayItem
                                            key={holiday.id}
                                            {...holiday}
                                            holidayTypes={holidayTypes}
                                            operator={
                                                operators.find((operator) => operator.id_operator === holiday.operator_id)?.name ??
                                                'Responsable non trouvé'
                                            }
                                        />
                                    ))}

                                    {!pastHolidays.length && (
                                        <Typography intrinsic="h4" color="grey" defaultSpacing>
                                            Aucune demande d'absence traitée
                                        </Typography>
                                    )}
                                </>
                            )}
                        </Container>
                    </HeaderToggle>

                    <div className="floating-button">
                        <Button
                            color="marine"
                            size="fullwidth"
                            icon={<BiPlus />}
                            iconColor="white"
                            iconPosition="forced-left"
                            iconSize={28}
                            onClick={() => navigate('/richesses-humaines/conges/new')}
                        >
                            <Typography intrinsic="h4">Nouvelle demande d'absence</Typography>
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};
